<template>
  <router-view />
</template>

<script setup>
import useSettingsStore from '@/store/modules/settings'
import { handleThemeStyle } from '@/utils/theme'
import { saveUrlParamsToStorage } from '@/utils/index'
import { onMounted, nextTick } from 'vue'

onMounted(() => {

  // 解析并存储URL参数到localStorage
  const params = saveUrlParamsToStorage()
  console.log('保存的URL参数结果:', params)
  
  nextTick(() => {
    // 初始化主题样式
    // handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
